<template>
  <div class="w-full md:text-center p-6 md:p-2 lg:p-3 xl:p-4" :class="mainHeaderColor">
    <ul class="md:inline-flex">
    <li
      class="my-4 md:mr-6 md:my-0 text-lg font-extrabold cursor-pointer"
      :class="mainHeaderFont"
      @click="this.chooseCityScreen()"
      >{{ getCityName() }} <BIconCaretLeftFill class="inline -rotate-90" /></li
    >
    <!-- <router-link :to="{name: 'index', params: {planType: 'voce'}}" class="mr-6 text-sm font-extrabold cursor-pointer">Você</router-link>
    <router-link :to="{name: 'index', params: {planType: 'empresa'}}" class="mr-6 text-sm font-extrabold cursor-pointer">Empresa</router-link> -->
    <li
      class="my-4 md:mr-6 md:my-0 text-lg font-extrabold cursor-pointer"
      :class="mainHeaderFont"
      @click="this.saveType(1)"
      >Para Você</li
    >
    <li
      class="text-lg font-extrabold my-4 md:mr-6 md:my-0 cursor-pointer"
      :class="mainHeaderFont"
      @click="this.saveType(2)"
      >Para Empresas</li
    >
    <li
      class="text-lg font-extrabold cursor-pointer hide-on-large"
      :class="mainHeaderFont"
      >
      <!-- <a href="tel:+553136149300"> -->
        
         <a href="https://wa.me/553136149300" target="_blank">

    <!-- <BIconWhatsapp class="inline-block mr-2 text-[#25d366]" /> -->
     <!-- <img src="data:image/svg+xml;utf8;base64,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" style="width: 20px;" class="inline-block mr-3"> -->
    <BIconTelephoneFill class="inline-block" />
      (31)3614-9300</a></li
    >

    <li
      class="text-lg font-extrabold cursor-pointer hide-on-mobile"
      :class="mainHeaderFont"
      >
      <a href="https://wa.me/553136149300" target="_blank">
      <!-- <a href="tel:+553136149300" target="_blank"> -->
    <!-- <BIconWhatsapp class="inline-block mr-2 text-[#25d366]" /> -->
     <!-- <img src="data:image/svg+xml;utf8;base64,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" style="width: 20px;" class="inline-block mr-3"> -->
    <BIconTelephoneFill class="inline-block" />
      (31)3614-9300</a></li
    >
  </ul>

  </div>
  <div :class="mainMenuColor">
    <nav
      class="container px-2 py-4 mx-auto md:flex md:justify-between md:items-center"
    >
      <div class="flex items-center justify-between">
        <div>
          <router-link to="/" class="flex items-center">
            <img
              v-if="this.typeId == 2"
              src="@/assets/img/logo_nova_bco.png"
              height="10"
              class="h-12 md:h-14 mr-3 py-3"
              alt="Nova Telecom"
            />
            <img
              v-else
              src="@/assets/img/logo_nova.png"
              height="10"
              class="h-12 md:h-14 mr-3 py-3"
              alt="Nova Telecom"
            />
          </router-link>
        </div>
        <!-- Mobile menu button -->
        <div @click="toggleNav" class="flex md:hidden">
          <button
            type="button"
            class="text-main-purple-500 hover:text-main-purple-700 focus:outline-none focus:text-main-purple-700"
          >
            <svg viewBox="0 0 24 24" class="w-6 h-6 fill-current">
              <path
                fill-rule="evenodd"
                d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
              ></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- Mobile Menu open: "block", Menu closed: "hidden" -->

      <ul
        class="flex-col mt-8 space-y-2 md:flex md:space-y-0 md:flex-row md:items-center md:space-x-10 md:mt-0 font-bold text-main-purple-500 text-base md:text-sm lg:text-base"
        :class="showMenu ? 'flex' : 'hidden'"
      >
        <li>
          <router-link
            to="/sobre-nos"
            class="hover:font-bold md:p-2 lg:p-3 xl:p-4 py-2 block"
            :class="mainMenuFont"
            >Sobre nós</router-link
          >
        </li>
        <li>
          <router-link
            to="/planos"
            class="hover:font-bold md:p-2 lg:p-3 xl:p-4 py-2 block"
            :class="mainMenuFont"
            >Planos</router-link
          >
        </li>
        <li>
          <router-link
            to="/segunda-via"
            class="hover:font-bold md:p-2 lg:p-3 xl:p-4 py-2 block"
            :class="mainMenuFont"
            >Segunda Via</router-link
          >
        </li>
        <li>
          <router-link
            to="/faq"
            class="hover:font-bold md:p-2 lg:p-3 xl:p-4 py-2 block"
            :class="mainMenuFont"
            >FAQ</router-link
          >
        </li>
        <li>
          <router-link
            to="/ouvidoria"
            class="hover:font-bold md:p-2 lg:p-3 xl:p-4 py-2 block"
            :class="mainMenuFont"
            >Ouvidoria</router-link
          >
        </li>
        <li>
          <router-link
            to="/nova-mais"
            class="hover:font-bold md:p-2 lg:p-3 xl:p-4 py-2 block"
            :class="mainMenuFont"
            >Nova Mais</router-link
          >
        </li>
        <li>
          <a
            class="font-bold hover:font-black md:p-2 lg:p-3 xl:p-4 py-2 block hover:text-main-purple-300"
            :class="mainMenuFont"
            href="https://central.novatelecom.hubsoft.com.br/"
            target="_blank"
            >Fazer login</a
          >
        </li>
      </ul>
    </nav>
  </div>
</template>
<style scoped>
@media (orientation: landscape) {
  .hide-on-large {
    display: none;
  }
}

@media (orientation: portrait) {
  .hide-on-mobile {
    display: none;
  }
}
</style>
<script>
import CitySelection from "@/mixins/CitySelection";
import { ref } from "vue";
export default {
  setup() {
    let showMenu = ref(false);
    const toggleNav = () => (showMenu.value = !showMenu.value);
    return { showMenu, toggleNav };
  },
  props: {
    mainMenuFont: String,
    mainMenuColor: String,
    mainHeaderFont: String,
    mainHeaderColor: String
  },
  methods: {
    getCityName() {
      let varCity = parseInt($cookies.get("selectCity") )

      switch (varCity) {
        case 1:
          return "Belo Horizonte";
          break;
        case 2:
          return "Esmeraldas";
          break;
        case 3:
          return "Ribeirão das Neves";
          break;
        case 4:
          return "Sabará";
          break;
        case 5:
          return "Santa Luzia";
          break;
        case 6:
          return "Vespasiano";
          break;
        case 7:
          return "Justinópolis";
          break;
        
      }
    }    
  },
  data: () => ({
    menuColor: null,
    headerColor: null,
    headerFont: null,
  }),
  mixins: [CitySelection],
};
</script>